<template>
  <div class="row">
    <div class="col-12">
      <card>
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              :filterOfBusinesses="true"
              :filterOfUsers="true"
              :filterOfFarms="false"
              :isRequiredBusinesses="true"
              :filterOfLots="false"
              :classBusinesses="`col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6`"
              :classUsers="`col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6`"
            >
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
    </div>
    <div class="col-12">
      <div v-if="tableData.length > 0">
        <div class="row">
          <div class="col-12">
            <highcharts :options="actualChart"></highcharts>
          </div>
        </div>
        <card class="custom-shadow-card-header custom-table-responsive">
          <div v-if="isIndex()">
            <card-header
              :propPagination="pagination"
              @searchedQuery="searchedQuery"
              class="mr-3 mt-4"
            ></card-header>
            <master-table
              :infoTable="queriedData"
              :columns="tableColumns"
              :showColumnStatus="false"
            >
              <template slot="addColumns" v-if="isSuper()">
                <el-table-column :label="$t('common_words.details')">
                  <template slot-scope="props">
                    <div class="row">
                      <div class="col-12 text-center">
                        <a
                          v-tooltip.top-center="$t('common_words.view')"
                          class="btn-info btn-simple btn-link custom-margin-actions"
                          @click="handleView(props.$index, props.row)"
                        >
                          <em class="fa fa-eye custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </template>
            </master-table>
          </div>
          <not-index-permissions v-else />
          <card-footer ref="cardfooter" :propPagination="pagination" />
        </card>
      </div>
    </div>
    <div v-if="details && isSuper()" class="col-12">
      <card class="custom-shadow-card-header custom-table-responsive">
        <table aria-describedby="table-details" class="table">
          <tbody>
            <tr class="shadow-sm">
              <td>
                <h6>
                  <strong>{{ $t('common_words.name') }}:</strong>
                </h6>
                {{ detailSelected.first_name }} {{ detailSelected.last_name }}
              </td>
              <td>
                <h6>
                  <strong>{{ $t('common_words.email') }}:</strong>
                </h6>
                {{ detailSelected.email }}
              </td>
              <td>
                <h6>
                  <strong
                    >{{ $t('audit.total_time_in_system') }}({{
                      $t('audit.formatter_time')
                    }}):</strong
                  >
                </h6>
                {{ detailSelected.total_session_human }}
              </td>
              <td>
                <h6>
                  <strong>{{ $t('audit.total_active_sessions') }}:</strong>
                </h6>
                {{ detailSelected.sessions_count }}
              </td>
            </tr>
          </tbody>
        </table>
        <card-header
          :propPagination="paginationLog"
          @searchedQuery="searchedQueryLog"
          class="mr-3 mt-3"
        />
        <master-table
          :infoTable="queriedDataLog"
          :columns="tableColumnsLog"
          :showColumnStatus="false"
        ></master-table>
        <div
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap mt-2"
        >
          <div>
            <p class="card-category">
              {{ $t('table2.showing') }}
              {{ totalLog > 0 ? fromLog + 1 : 0 }}
              {{ $t('table2.a') }}
              {{ toLog }}
              {{ $t('table2.of') }}
              {{ totalLog }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="paginationLog.currentPage"
            :per-page="paginationLog.perPage"
            :total="paginationLog.total"
            pageFirst="false"
            pageLast="false"
          />
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { Chart } from 'highcharts-vue';
import { getDateToday } from 'src/util/Util';
import configTable from 'src/views/Pages/Dashboard/Log/LogAccessReport/logAccessReportTable';
import configTable2 from 'src/views/Pages/Dashboard/Log/LogAccessReport/sessionLogsDetailsTable';
import Filter from 'src/components/Filter/Filters.vue';
import Fuse from 'fuse.js';
import i18n from 'src/i18n';
import MixinCharts from 'src/util/mixinCharts';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';

export default {
  components: {
    [Filter.name]: Filter,
    highcharts: Chart,
  },
  data() {
    return {
      pagination: {},
      tableColumns: [],
      tableData: [],
      valueCollapse: null,
      activeName: 'filter',
      details: false,
      detailSelected: null,
      fuseSearchLog: null,
      searchQueryLog: '',
      paginationLog: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      tableColumnsLog: [],
      tableDataLog: [],
      actualChart: [],
    };
  },
  computed: {
    ...configTable().Search,
    ...configTable2().SearchLog,
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
    dateToday() {
      return getDateToday();
    },
  },
  mixins: [MixinCharts, MixinMasters, MixinPermissions, MixinMenu, MixinForm],
  watch: {
    '$i18n.locale': ['setupTable', 'setupTableLog'],
  },
  methods: {
    handleCollapse(val) {
      this.valueCollapse = val;
    },
    handleFilter(data) {
      this.dataFilter = { ...data };
      this.getData();
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
    getData() {
      this.showHideLoading(true);
      let data = this.dataFilter;

      if (data.bySel === 'Año') {
        data.datei += '-01-01';
        data.datef += '-12-31';
      }
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      data.route = 'audit/logins';
      data.timeZone = timeZone;
      Axios.postMasters(data)
        .then((response) => {
          this.tableData = response.data.data.data;
          const columnChart = response.data.data.column_chart;
          if (this.tableData.length == 0) {
            SweetAlert.warning(i18n.t('common_words.unavailable_data'));
          } else {
            this.actualChart = this.columns(columnChart);
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    handleView(index, row) {
      this.tableDataLog = row.sessions;
      this.detailSelected = row;
      this.fuseSearchLog = new Fuse(this.tableDataLog, {
        useExtendedSearch: true,
        threshold: 0.3,
        keys: this.tableColumnsLog.map((prop) => {
          return prop.prop;
        }),
      });
      this.details = true;
      this.paginationLog.perPage = 5;
      this.paginationLog.currentPage = 1;
      this.paginationLog.total = this.totalLog;
    },
    searchedQueryLog(searchedValue) {
      this.searchQueryLog = searchedValue;
    },
    setupTableLog() {
      const { TableLog, SearchLog } = configTable2();

      this.TableLog = TableLog;
      this.SearchLog = SearchLog;
      //merge mantener el objeto reactivo que Vue creó desde el inicio.
      Object.assign(this.paginationLog, TableLog.pagination);
      this.tableColumnsLog = TableLog.tableColumns;
    },
  },
  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.setupTableLog();
    }
  },
  mounted() {
    this.selectedItemOnMenu('logreports');
  },

  destroyed() {
    this.deselectedItemOnMenu('logreports');
  },
};
</script>
